import { render, staticRenderFns } from "./bulk-add.vue?vue&type=template&id=1ed48e14&"
import script from "./bulk-add.vue?vue&type=script&lang=js&"
export * from "./bulk-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports